import React from 'react';
import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = () => (
    <ul className={classes.NavigationItems}>
        <NavigationItem link="/" exact>overview</NavigationItem>
        <NavigationItem link="/curriculum">curriculum</NavigationItem>
        <NavigationItem link="/on-site">on-site</NavigationItem>
        <NavigationItem link="/remote">remote</NavigationItem>
        <NavigationItem link="/about">why procode </NavigationItem>
        <NavigationItem link="/events">events </NavigationItem>
    </ul>
);

export default navigationItems;


// WEBPACK FOOTER //
// ./src/Components/Navigation/NavigationItems/NavigationItems.js